import { render } from "./Dex.vue?vue&type=template&id=0637c2e2"
import script from "./Dex.vue?vue&type=script&lang=js"
export * from "./Dex.vue?vue&type=script&lang=js"

import "./Dex.vue?vue&type=style&index=0&id=0637c2e2&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__